import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RecommendedRouteToken {
  
  private _recommendedRouteToken = signal<string | null>(null);
  public recommendedRouteToken = this._recommendedRouteToken.asReadonly();
  
  public setRecommendedRouteToken(token: string): void {
    this._recommendedRouteToken.set(token);
  }
}
